import { makeAutoObservable, runInAction } from 'mobx';

import { alertController } from "../../../../Controllers/AlertController";
import { userAccountController } from "../../../../Controllers/UserAccountController";
import { loginSignupController } from "../LoginSignupController";
import { issueController } from "../../../../Controllers/IssueController";

export class LoginController {
  username = ""
  password = ""
  rememberUser: boolean = false
  loading = false;

  setLogin(value: string) {
    runInAction(() => this.username = value)
  }

  setPassword(value: string) {
    runInAction(() => this.password = value)
  }

  setRememberMe(value: boolean) {
    runInAction(() => this.rememberUser = value)
  }

  login = async () => {
    runInAction(() => {
      this.loading = true
      issueController.loadingIssues = true // Note: this is to show the issues-loading spinner at this point already
    })

    try {
      const apiUser = await userAccountController.login(this.username, this.password, this.rememberUser)

      if (apiUser) {
        issueController.clearIssues()
        loginSignupController.setLoginSignupWindowVisible(false)
        alertController.displayAlert(
          "Login successful",
          null,
          "success",
          4000
        )
        await userAccountController.initializeUser()
        await issueController.pullMoreIssues()
      }

      runInAction(() => this.loading = false)

      return apiUser
    } catch (error) {
      alertController.displayAlert("Error while trying to log in", (error as Error).message, "error")
      runInAction(() => this.loading = false)
    }
  }

  goToSignup = () => {
    loginSignupController.setCurrentWindow("SIGNUP")
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const loginController = new LoginController()
